/**
 * Filename Normalizer Utility
 * Matches backend normalization algorithm for presenter name matching
 * Feature: User Management (002-user-management) - Phase 5 US4 - T108
 */

export const filenameNormalizer = {
  /**
   * Normalize filename for matching
   * Case-insensitive, spaces → underscores, remove extension
   * Must match backend algorithm exactly
   * @param {string} filename - Filename or presenter name
   * @returns {string} Normalized name
   */
  normalize(filename) {
    if (!filename) return '';

    // Remove extension if present
    const nameWithoutExt = filename.replace(/\.(jpg|jpeg|png|gif|bmp|webp)$/i, '');
    
    // Convert to lowercase
    // Replace multiple spaces with single underscore
    // Trim underscores from start/end
    return nameWithoutExt
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '');
  },

  /**
   * Check if filename matches presenter name
   * @param {string} filename - Uploaded filename
   * @param {string} presenterName - Presenter name from session
   * @returns {boolean} True if normalized versions match
   */
  matches(filename, presenterName) {
    return this.normalize(filename) === this.normalize(presenterName);
  },

  /**
   * Preview normalization (for UI display)
   * @param {string} filename - Original filename
   * @returns {Object} { original: string, normalized: string }
   */
  preview(filename) {
    return {
      original: filename,
      normalized: this.normalize(filename)
    };
  }
};

export default filenameNormalizer;
